import apiClient from '../utils/apiClient';
import { ResponseDto } from "../types/Helper";
import { DuplicateDto } from '../types/Folder';
import { DuplicateFilesDto, GetFoldersByUserIdDto } from '../types/FolderPermission';

export const duplicateFolder = async (duplicateDto: DuplicateDto): Promise<ResponseDto<GetFoldersByUserIdDto>> => {
  let duplicateUrl = `/portal/duplicate/duplicate-folder/${duplicateDto.userId}/${duplicateDto.folderId}`;
  if (duplicateDto.parentFolderId !== null) {
    duplicateUrl += `?parentFolderId=${duplicateDto.parentFolderId}`;
  }

  const response = await apiClient.post<ResponseDto<GetFoldersByUserIdDto>>(duplicateUrl);
  return response.data;
};
export const duplicateFile = async (duplicateDto: DuplicateDto): Promise<ResponseDto<DuplicateFilesDto | null>> => {
  const duplicateUrl = `/portal/duplicate/duplicate-file/${duplicateDto.userId}/${duplicateDto.fileId}`;

  const response = await apiClient.post<ResponseDto<DuplicateFilesDto | null>>(duplicateUrl);
  return response.data;
};